import React from "react";
import { Box, Typography, Stack, keyframes } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { useNavigate } from "react-router-dom";
import { projectNavigatePath } from "../../../../Utils/detailsNavigatePath";

export default function ProjectCard({ project }) {
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => navigate(projectNavigatePath(project))}
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: 200, md: 350 },
        borderRadius: "24px",
        overflow: "hidden",
        mb: { xs: 2, md: 3 },
        cursor: "pointer",
        "&:hover .overlay": { opacity: 1 },
        "&:hover .bg-img": { transform: "scale(1.1)" },
        "&:hover .content": { transform: "translateY(0)", opacity: 1 },
      }}
    >
      <Box
        className="bg-img"
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${import.meta.env.VITE_URL + project?.image_path?.[0]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          transition: "transform 0.6s cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      />
      <Box
        className="overlay"
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.1) 100%)",
          opacity: 0.6,
          transition: "opacity 0.4s ease",
        }}
      />
      <Stack
        className="content"
        justifyContent="space-between"
        sx={{
          position: "absolute",
          inset: 0,
          p: 3,
          opacity: 0,
          transform: "translateY(20px)",
          transition: "all 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
        }}
      >
        <Box display="flex" justifyContent="flex-end">
          <Box
            sx={{
              p: 1,
              bgcolor: "#00ffcc",
              color: "#000",
              borderRadius: "50%",
              display: "flex",
            }}
          >
            <ArrowOutwardIcon
              fontSize="small"
              sx={{ transform: "rotate(-90deg)" }}
            />
          </Box>
        </Box>
        <Box>
          <Typography
            sx={{
              color: "#00ffcc",
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: "1px",
              mb: 0.5,
            }}
          >
            {project?.category}
          </Typography>
          <Typography
            sx={{
              color: "#fff",
              fontSize: { xs: 16, md: 24 },
              fontWeight: 700,
            }}
          >
            {project?.name}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
